module.exports = __webpack_public_path__ + "img/UG.4ce82391.png";